import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <section className="contact-section">
      <div className="contact-overlay"></div>
      
      <div className="contact-content">
        <div className="container">
          <div className="contact-text">
            <div className="contact-line"></div>
            <h2 className="contact-title">Get in Touch with Sri Veda Gurukulam</h2>
            <p className="contact-description">
              For admissions, ritual services, or to visit the Gurukulam, please reach 
              out to us. We will be happy to guide you.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;